<div class="container p-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>Listado de Operaciones</h2>
    <button mat-icon-button (click)="cerrar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Filtros -->
  <form [formGroup]="filtrosForm" class="mb-4">
    <div class="row">
      <div class="col-md-3 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fecha Desde</mat-label>
          <input
            matInput
            [matDatepicker]="pickerDesde"
            formControlName="fechaDesde"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerDesde"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerDesde></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-md-3 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fecha Hasta</mat-label>
          <input
            matInput
            [matDatepicker]="pickerHasta"
            formControlName="fechaHasta"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerHasta"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerHasta></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-md-3 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Estado de Pago</mat-label>
          <mat-select formControlName="pagoRecibido">
            <mat-option value="">Todos</mat-option>
            <mat-option [value]="true">Pagado</mat-option>
            <mat-option [value]="false">Pendiente</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-3 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Ordenar por</mat-label>
          <mat-select formControlName="ordenarPor">
            <mat-option value="numeroPedido">Nº Pedido</mat-option>
            <mat-option value="fechaOrden">Fecha</mat-option>
            <mat-option value="cantidadEspacioMB">Espacio</mat-option>
            <mat-option value="cantidadTiempoHoras">Tiempo</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>

  <!-- Tabla de Operaciones -->
  <div
    class="table-responsive"
    style="max-height: calc(80vh - 300px); overflow-y: auto; overflow-x: auto"
  >
    <table
      mat-table
      [dataSource]="operacionesFiltradas"
      class="mat-elevation-z2 w-100"
      style="max-height: calc(80vh - 180px); overflow-y: auto"
    >
      <!-- Numero de Pedido Columna -->
      <ng-container matColumnDef="numeroPedido">
        <th mat-header-cell *matHeaderCellDef>Nº Pedido</th>
        <td mat-cell *matCellDef="let operacion">
          {{ operacion.referenciaGdp || generarNumeroPedidoGDP(operacion.fechaOrden) }}
        </td>
      </ng-container>

      <!-- Fecha Columna -->
      <ng-container matColumnDef="fechaOrden">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let operacion">
          {{ operacion.fechaOrden | date : "dd/MM/yyyy HH:mm" }}
        </td>
      </ng-container>

      <!-- Espacio Columna -->
      <ng-container matColumnDef="espacio">
        <th mat-header-cell *matHeaderCellDef class="text-center">Espacio</th>
        <td mat-cell *matCellDef="let operacion">
          {{ operacion.cantidadEspacioMB }} MB ({{
            operacion.precioPorMB | currency : "EUR"
          }}/MB)
        </td>
      </ng-container>

      <!-- Tiempo Columna -->
      <ng-container matColumnDef="tiempo">
        <th mat-header-cell *matHeaderCellDef class="text-center">Tiempo</th>
        <td mat-cell *matCellDef="let operacion">
          {{ operacion.cantidadTiempoHoras }} h ({{
            operacion.precioPorHora | currency : "EUR"
          }}/h)
        </td>
      </ng-container>

      <!-- Total Columna -->
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef class="text-center">
          Importe sin IVA
        </th>
        <td mat-cell *matCellDef="let operacion">
          {{ calcularTotal(operacion) | currency : "EUR" }}
        </td>
      </ng-container>

      <!-- Factura Columna -->
      <ng-container matColumnDef="factura">
        <th mat-header-cell *matHeaderCellDef class="text-center">Factura</th>
        <td mat-cell *matCellDef="let operacion" class="text-center">
          <span *ngIf="operacion.facturaExpansionCreada">
            {{ operacion.facturaExpansionSerie }}-{{ operacion.facturaExpansionNumero }}
          </span>
          <span *ngIf="!operacion.facturaExpansionCreada && operacion.cantidadTiempoHoras > 0">—</span>
        </td>
      </ng-container>

      <!-- Recargo Equivalencia -->
      <ng-container matColumnDef="recargoEquivalencia">
        <th mat-header-cell *matHeaderCellDef class="text-center">
          <div class="d-flex justify-content-center flex-column">
            <span>Recargo </span>
            <span>Equivalencia</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let operacion">
          <input
            type="checkbox"
            name="recargoEquivalencia"
            id="recargoEquivalencia"
            [ngModel]="operacion.recargoEquivalencia"
            (ngModelChange)="cambiarRecargoEquivalencia(operacion, $event)"
          />
        </td>
      </ng-container>

      <!-- Estado Pago Columna -->
      <ng-container matColumnDef="pagoRecibido">
        <th mat-header-cell *matHeaderCellDef class="text-center">Estado</th>
        <td mat-cell *matCellDef="let operacion">
          <button
            style="border: none; background-color: transparent; cursor: default"
            [disabled]="
              ['admin', 'supervisor', 'pedidos'].includes(
                this.crmService.userLogin.rol
              )
                ? false
                : true
            "
          >
            <mat-chip-list style="cursor: default">
              <mat-chip
                *ngIf="!operacion.fechaEjecucion"
                (click)="aplicarOperacion(operacion)"
                [color]="operacion.fechaEjecucion ? 'primary' : 'secondary'"
                [title]="
                  operacion.fechaEjecucion
                    ? 'Aplicado'
                    : 'Aplicar la operación sin marcar como cobrado'
                "
                [style.cursor]="
                  operacion.fechaEjecucion ? 'default' : 'pointer'
                "
              >
                {{ operacion.fechaEjecucion ? "Aplicado" : "Sin aplicar" }}
              </mat-chip>
              <mat-chip
                (click)="cambiarEstadoPago(operacion)"
                [color]="operacion.pagoRecibido ? 'secondary' : 'warn'"
                [title]="
                  operacion.pagoRecibido
                    ? 'Cobrado'
                    : 'Marcar como cobrado (y aplicar si no está aplicado)'
                "
                selected
                [style.opacity]="
                  ['admin', 'supervisor', 'pedidos'].includes(
                    this.crmService.userLogin.rol
                  )
                    ? 1
                    : 0.5
                "
                [style.cursor]="operacion.pagoRecibido ? 'default' : 'pointer'"
              >
                {{
                  operacion.pagoRecibido
                    ? (operacion.fechaEjecucion | date : "dd/MM/yyyy") ||
                      "Cobrado"
                    : "Sin cobrar"
                }}
              </mat-chip>
            </mat-chip-list>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef class="text-center">Acciones</th>
        <td mat-cell *matCellDef="let operacion">
          <div class="d-flex justify-content-center" style="gap: 2px">
            <button
              *ngIf="!operacion.pagoRecibido && !operacion.fechaEjecucion"
              mat-icon-button
              (click)="eliminarOperacion(operacion)"
              title="Eliminar"
              [style.opacity]="
                ['admin', 'supervisor', 'pedidos'].includes(
                  this.crmService.userLogin.rol
                )
                  ? 1
                  : 0.5
              "
              [disabled]="
                ['admin', 'supervisor', 'pedidos'].includes(
                  this.crmService.userLogin.rol
                )
                  ? false
                  : true
              "
            >
              <mat-icon
                style="font-size: 16px"
                class="text-secondary opacity__onhover"
                >delete</mat-icon
              >
            </button>
            <!-- <div
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <button
                mat-icon-button
                title="Generar Documento Pedido"
                (click)="generarPedidoGDP(operacion, tipoEmpresa)"
              >
                <mat-icon class="text-secondary opacity__onhover">
                  description
                </mat-icon>
              </button>
              <select [(ngModel)]="tipoEmpresa" style="font-size: 8px">
                <option value="dormaexpansion" selected>Dorma Expansión</option>
                <option value="dormadiseno">Dorma Diseño</option>
              </select>
            </div> -->
            <div
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <button
                mat-icon-button
                title="Generar Documento Pedido"
                (click)="generarPedidoGDP(operacion, 'dormaexpansion')"
              >
                <mat-icon
                  style="font-size: 16px"
                  class="text-secondary opacity__onhover"
                >
                  description
                </mat-icon>
              </button>
              <span style="font-size: 8px; text-align: center; width: 100%"
                >Dorma</span
              >
              <span style="font-size: 8px; text-align: center; width: 100%"
                >Expansión</span
              >
            </div>
            <div
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <button
                mat-icon-button
                title="Generar Documento Pedido"
                (click)="generarPedidoGDP(operacion, 'dormadiseno')"
              >
                <mat-icon
                  style="font-size: 16px"
                  class="text-secondary opacity__onhover"
                >
                  description
                </mat-icon>
              </button>
              <span style="font-size: 8px; text-align: center; width: 100%"
                >Dorma</span
              >
              <span style="font-size: 8px; text-align: center; width: 100%"
                >Diseño</span
              >
            </div>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="[
          'numeroPedido',
          'fechaOrden',
          'espacio',
          'tiempo',
          'total',
          'factura',
          'recargoEquivalencia',
          'pagoRecibido',
          'acciones'
        ]"
      ></tr>
      <tr
        mat-row
        *matRowDef="
          let row;
          columns: [
            'numeroPedido',
            'fechaOrden',
            'espacio',
            'tiempo',
            'total',
            'factura',
            'recargoEquivalencia',
            'pagoRecibido',
            'acciones'
          ]
        "
      ></tr>
    </table>
  </div>

  <!-- Mensaje cuando no hay datos -->
  <div *ngIf="operacionesFiltradas.length === 0" class="text-center mt-4">
    <p class="text-muted">
      No se encontraron operaciones que coincidan con los filtros
    </p>
  </div>
</div>
